module.exports = __webpack_public_path__ + "img/zz_kb.6cadbc58.png";